import React from 'react';

import './Gallery.css';

import Painting from './Painting/Painting';

import SectionContainer from '../../common/SectionContainer/SectionContainer';

import PaintingModalBody from './PaintingModalBody/PaintingModalBody';

import Button from '../../common/Button/Button';

import useRequest from '../../common/hooks/useRequest';

import DataLoading from '../../common/DataLoading/DataLoading';

import DataError from '../../common/DataError/DataError';

import { galleryDataURL } from '../../common/utilities/URLs/getURLs';

import {

  ButtonType,

  ModalDataType,

  PaintingDataType,

} from '../../common/types';

import {

  ensureAbsoluteUrl,

  getButtonLabel,

  getButtonStyle,

} from '../../common/utilities/buttons/getButtonStyle';



type PropsTypes = {

  setModalData: React.Dispatch<React.SetStateAction<ModalDataType | null>>;

};



const renderButton = (

  { textSlug, link, label: customLabel }: ButtonType,

  setModalData: React.Dispatch<React.SetStateAction<ModalDataType | null>>,

): React.ReactElement => {

  const buttonStyle = getButtonStyle(textSlug);

  const label = getButtonLabel(textSlug, buttonStyle, customLabel);

  const theCallback =

    textSlug === 'close' ? () => setModalData(null) : null;

  const isDisabled = !theCallback && !link;

  const resolvedLink = ensureAbsoluteUrl(link);



  return (

    <Button

      key={ label }

      link={ resolvedLink }

      callback={ theCallback }

      buttonData={ { ...buttonStyle, label } }

      isDisabled={ isDisabled }

    />

  );

};



const renderButtons = (

  buttons: ButtonType[],

  setModalData: React.Dispatch<React.SetStateAction<ModalDataType | null>>,

): React.ReactElement[] => [

  ...buttons.map((button) => renderButton(button, setModalData)),

  renderButton({ textSlug: 'close', link: '' }, setModalData),

];



export const Gallery = ({ setModalData }: PropsTypes): JSX.Element => {

  const { data: myData, isLoading, error, retryFetchData } =

    useRequest<PaintingDataType[]>(galleryDataURL);



  const handlePictureClick = (idx: number) => {

    if (!myData) return;

    const pictureData = myData[idx];

    const pictureBody = <PaintingModalBody data={ pictureData } />;

    const header = pictureData.name;

    const buttons = renderButtons(pictureData.buttons, setModalData);

    setModalData({

      header,

      body: pictureBody,

      buttons,

      comments: pictureData.comments,

    });

  };



  let body: React.ReactNode = null;



  if (error) {

    body = <DataError retryFetchData={ retryFetchData } />;

  } else if (isLoading) {

    body = <DataLoading />;

  } else if (myData) {

    body = myData.map((painting, idx) => (

      <Painting

        key={ painting.name }

        painting={ painting }

        idx={ idx }

        handlePictureClick={ handlePictureClick }

      />

    ));

  }



  return (

    <SectionContainer titleSlug='gallery' isCollapsible>

      <div className='Gallery'>{ body }</div>

    </SectionContainer>

  );

};



export default Gallery;

